import React, { createContext, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import enMessages from "../../config/locales/en.json";
import zhMessages from "../../config/locales/zh.json";
import frMessages from "../../config/locales/fr.json";

const messagesMap: Record<string, Record<string, string>> = {
  en: enMessages,
  zh: zhMessages,
  fr: frMessages,
};

interface LocaleContextType {
  locale: string;
  setLocale: (locale: string) => void;
}

export const LocaleContext = createContext<LocaleContextType>({
  locale: "en",
  setLocale: () => {},
});

export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<string>("en");
  const messages = messagesMap[locale] || messagesMap.en;

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages} defaultLocale="en">
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);
export default LocaleContext;
